import { EvidenceUnit, NewOrderType, PhysDescStructured } from 'types';

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum UrlRoute {
  ARCHIVAL_AID = '/pomucky',
  ARCHIVAL_COLLECTION = '/fondy',
  ARCHIVAL_UNIT = '/archivalie',
  ARCHIVAL_UNIT_PRIVATE = '/soukrome-archivalie',
  ARCHIVAL_AID_PRIVATE = '/soukrome-pomucky',
}
export enum ApiRoute {
  ARCHIVAL_AID = 'archival-aid-metadata',
  ARCHIVAL_COLLECTION = 'archival-collection',
  ARCHIVAL_UNIT = 'archival-unit/public/view',
  ARCHIVAL_UNIT_LIST = 'archival-unit/public/list',
  ARCHIVAL_UNIT_PRIVATE = 'archival-unit/private/view',
  ARCHIVAL_AID_PRIVATE = 'archival-aid/private',
  RESEARCH_SHEET = 'research-sheet',
  COUNTRY = 'country',
  EAD = 'ead',
}

export enum MetadataApiRoute {
  ARCHIVAL_AID = '/api/archival-aid-metadata',
  ARCHIVAL_COLLECTION = '/api/archival-collection',
  ARCHIVAL_UNIT = '/api/archival-unit/public',
  ARCHIVAL_UNIT_PRIVATE = '/api/archival-unit/private',
  ARCHIVAL_AID_PRIVATE = '/api/archival-aid/private',
  ORIGINATOR = '/api/originator',
}

export enum PageKey {
  DETAIL_ARCHIVAL_COLLECTION = 'DETAIL_ARCHIVAL_COLLECTION',
  DETAIL_ARCHIVAL_AID = 'DETAIL_ARCHIVAL_AID',
  DETAIL_ARCHIVAL_UNIT = 'DETAIL_ARCHIVAL_UNIT',
  DETAIL_ARCHIVAL_UNIT_PRIVATE = 'DETAIL_ARCHIVAL_UNIT_PUBLIC',
  DETAIL_ARCHIVAL_AID_PRIVATE = 'DETAIL_ARCHIVAL_AID_PUBLIC',
  PORTFOLIO_RESEARCH_SHEET = 'PORTFOLIO_RESEARCH_SHEET',
  PORTFOLIO_RESEARCH_SHEET_NEW = 'PORTFOLIO_RESEARCH_SHEET_NEW',
  PORTFOLIO_RESEARCH_SHEET_REWORK = 'PORTFOLIO_RESEARCH_SHEET_REWORK',
  PORTFOLIO_PROFILE = 'PORTFOLIO_PROFILE',
  PORTFOLIO_ORDER_NEW = 'PORTFOLIO_ORDER_NEW',
  PORTFOLIO_ORDER_HISTORY = 'PORTFOLIO_ORDER_HISTORY',
  PORTFOLIO_ORDER_HISTORY_REWORK = 'PORTFOLIO_ORDER_HISTORY_REWORK',
  PORTFOLIO_LENT = 'PORTFOLIO_LENT',
  PORTFOLIO_LENT_DIGITAL = 'PORTFOLIO_LENT_DIGITAL',
  PORTFOLIO_LENT_PHYSICAL = 'PORTFOLIO_LENT_PHYSICAL',
  PORTFOLIO_LENT_HISTORY = 'PORTFOLIO_LENT_HISTORY',
  PORTFOLIO_LENT_HISTORY_DIGITAL = 'PORTFOLIO_LENT_HISTORY_DIGITAL',
  PORTFOLIO_LENT_HISTORY_PHYSICAL = 'PORTFOLIO_LENT_HISTORY_PHYSICAL',
  PORTFOLIO_LENT_HISTORY_REGISTERED = 'PORTFOLIO_LENT_HISTORY_REGISTERED',
  PORTFOLIO_FAVOURITE = 'PORTFOLIO_FAVOURITE',
  PORTFOLIO_RESEARCHER_NEW_ORDER = 'PORTFOLIO_RESEARCHER_NEW_ORDER ',
  EAD = 'DETAIL_EAD',
}

export enum GeneralSearchEntityType {
  ARCHIVAL_COLLECTION = 'ARCHIVAL_COLLECTION',
  ARCHIVAL_AID = 'ARCHIVAL_AID',
  ARCHIVAL_UNIT = 'ARCHIVAL_UNIT',
  ORIGINATOR = 'ORIGINATOR',
  EAD_NODE = 'EAD_NODE',
  // eadnode upresnenie
  SERIES = 'SERIES',
  FILE = 'FILE',
}

export const GeneralSearchTypeToPath: Record<
  GeneralSearchEntityType,
  string
> = {
  ARCHIVAL_COLLECTION: 'fondy',
  ARCHIVAL_AID: 'pomucky',
  ARCHIVAL_UNIT: 'archivalie-switch',
  EAD_NODE: 'pomucky',
  ORIGINATOR: 'rejstriky-detail',
  SERIES: 'pomucky',
  FILE: 'pomucky',
};

export enum CurrentLocation {
  ARCHIVE = 'ARCHIVE',
  STOCK_TO_RETURN = 'STOCK_TO_RETURN',
  STOCK_KEEP = 'STOCK_KEEP',
  RESEARCHER = 'RESEARCHER',
}

export enum GridBodyType {
  DETAIL = 'DETAIL',
  ORDER = 'ODER',
}

export enum AisOrderState {
  SUBMITTED = 'SUBMITTED',
  REWORKED = 'REWORKED',
  TO_REWORK = 'TO_REWORK',
  DENIED = 'DENIED',
  PROCESSING = 'PROCESSING',
  PARTIALLY_READY = 'PARTIALLY_READY',
  READY = 'READY',
  COMPLETED = 'COMPLETED',
}

export enum ResearchSheetState {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  RETURNED = 'RETURNED',
  SUBMITTED = 'SUBMITTED',
  REWORKED = 'REWORKED',
  DENIED = 'DENIED',
  INVALIDATED = 'INVALIDATED',
}

export enum ArchivalEntityType {
  ARCHIVAL_COLLECTION = 'ARCHIVAL_COLLECTION',
  ARCHIVAL_AID = 'ARCHIVAL_AID',
  ARCHIVAL_UNIT = 'ARCHIVAL_UNIT',
  EAD_NODE = 'EAD_NODE',
}

export enum Sex {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum ProofOfIdentityType {
  CAS = 'CAS',
  ID_CARD = 'ID_CARD',
  PASSPORT = 'PASSPORT',
  OTHER = 'OTHER',
}

export enum ResearchCategory {
  SCIENTIFIC_PUBLICATIONS = 'SCIENTIFIC_PUBLICATIONS',
  SCIENTIFIC_EDITIONS = 'SCIENTIFIC_EDITIONS',
  GENEALOGY = 'GENEALOGY',
  PERSONAL = 'PERSONAL',
  JOURNALISTIC = 'JOURNALISTIC',
  EXPOSITION = 'EXPOSITION',
  OFFICE = 'OFFICE',
  CHRONICLE = 'CHRONICLE',
}

export enum ResearchSheetType {
  PERSONAL = 'PERSONAL',
  CREDENTIAL = 'CREDENTIAL',
}

export enum AuthenticationLevel {
  BASIC = 'BASIC',
  ADMIN = 'ADMIN',
}

export enum Language {
  CZ = 'CZ',
  EN = 'EN',
  DE = 'DE',
}

export enum NotificationType {
  APPLICATION = 'APPLICATION',
  EMAIL = 'EMAIL',
}

export enum AccessType {
  PUBLIC = 'PUBLIC',
  REGISTERED = 'REGISTERED',
  PRIVATE = 'PRIVATE',
}

export enum ReportTemplateType {
  RESEARCH_SHEET = 'RESEARCH_SHEET',
  LOAN = 'LOAN',
  ORDER = 'ORDER',
  ARCHIVAL_AID = 'ARCHIVAL_AID',
  ARCHIVAL_COLLECTION = 'ARCHIVAL_COLLECTION',
  ORIGINATOR = 'ORIGINATOR',
  PRIVATE_ARCHIVAL_UNIT = 'PRIVATE_ARCHIVAL_UNIT',
  PUBLIC_ARCHIVAL_UNIT = 'PUBLIC_ARCHIVAL_UNIT',
}

export enum TextLocation {
  HOMEPAGE = 'HOMEPAGE',
  CONTACTS = 'CONTACTS',
  INFORMATION = 'INFORMATION',
  BADATELNA = 'BADATELNA',
  GUIDE = 'GUIDE',
}

export enum EadNodeLevel {
  FONDS = 'fonds',
  SUBFONDS = 'subfonds',
  SERIES = 'series',
  SUBSERIES = 'subseries',
  ITEM = 'item',
  OTHERLEVEL = 'otherlevel',
}

export enum AggregationFamily {
  BUCKET = 'BUCKET',
  MATRIX = 'MATRIX',
  METRIC = 'METRIC',
  PIPELINE = 'PIPELINE',
}

export enum BucketAggregator {
  TERMS = 'TERMS',
  FILTERS = 'FILTERS',
}

//TODO:
export const EadNodeLevelText: Record<EadNodeLevel, string> = {
  fonds: 'soubor',
  subfonds: 'subfonds',
  item: 'item',
  otherlevel: 'otherlevel',
  series: 'series',
  subseries: 'subseries',
};

export const getQuantityLabel = ({
  evidenceUnit,
  levelLabel,
}: {
  evidenceUnit: EvidenceUnit;
  levelLabel?: string;
}) => {
  if (levelLabel?.toUpperCase() !== 'složka'.toUpperCase()) {
    return 'Počet';
  }
  const { unitKind } = evidenceUnit;
  if (unitKind === 'fas' || unitKind === 'kar') {
    return 'Počet';
  }
  return 'Počet archiválií';
};

export const EvidenceUnitLabels: Record<
  keyof EvidenceUnit,
  { render: boolean; label: string }
> = {
  quantity: { label: 'Počet', render: false },
  dimensions: { label: 'Kvantita', render: true },
  unitKind: { label: 'Typ jednotky', render: false },
  material: { label: 'Látka záznamu', render: true },
  medium: { label: 'Nosič', render: true },
  mediumAdjustment: { label: 'Adjustace', render: true },
  techniqueDetail: { label: 'Technika záznamu', render: true },

  unitKindLabel: { label: 'Typ archiválie [DO NOT RENDER]', render: false },
  imprintImagePhysFacet: {
    label: 'Popis obrazu v poli typáře či otisku',
    render: true,
  },
  legendPhysFacet: { label: 'Legenda, opis, nápis, exerque', render: true },
  imprintOrderPhysFacet: { label: 'Pořadí otisku', render: true },
  imprintCountPhysFacet: {
    label: 'Počet otisků původní a současný',
    render: true,
  },
  corroboratioPhysFacet: {
    label: 'Koroborace dokumentu, k němuž byl popisovaný otisk připojen',
    render: true,
  },
  techniquePhysFacet: { label: 'Technika záznamu', render: true },
  writing: { label: 'Písmo', render: true },
};

export const OrderTypeText: Record<NewOrderType, string> = {
  BASIC: 'Do Badatelny',
  ORIGIN_LTP: 'LTP pro původce',
  ORIGIN_ORIGINAL: 'Originál pro původce',
};

export const getTirazPhysDescStructuredLabel = (
  so: PhysDescStructured
): string => {
  if (so.unitKind === 'desc_units') {
    return 'Počet jednotek popisu';
  }
  return 'Rozsah zpřístupněných archiválií';
};
